import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const socialLinks = [
    { icon: "Github", url: "https://github.com", label: "GitHub", handle: "@mikeooforka1" },
    { icon: "Linkedin", url: "https://linkedin.com", label: "LinkedIn", handle: "Oforka Michael" },
    { icon: "Twitter", url: "https://twitter.com", label: "Twitter", handle: "@mikedev_pro" },
    { icon: "Mail", url: "mailto:contact@mikedev.pro", label: "Email", handle: "mikeoforka7@gmail.com" }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-primary/10 via-card to-accent/10 rounded-3xl p-8 md:p-12 lg:p-16 border border-primary/20 relative overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 right-0 w-96 h-96 bg-primary rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl" />
          </div>

          <div className="relative text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
              <div className="w-2 h-2 rounded-full bg-success animate-pulse-glow" />
              <span className="text-sm font-medium text-primary">Available for New Projects</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground mb-6">
              Let's Build Something Great Together
            </h2>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-8 md:mb-12 leading-relaxed">
              Whether you're a startup founder with a vision, an agency needing a reliable technical partner, or an enterprise team building the next big thing—I'm here to help turn your ideas into production-ready solutions.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <Link to="/contact">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Rocket"
                  iconPosition="left"
                  className="w-full sm:w-auto"
                >
                  Start Your Project
                </Button>
              </Link>
              <Link to="/portfolio">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Briefcase"
                  iconPosition="left"
                  className="w-full sm:w-auto"
                >
                  View My Work
                </Button>
              </Link>
            </div>

            <div className="border-t border-border pt-8 md:pt-12">
              <p className="text-sm text-muted-foreground mb-6">Connect with me on social media</p>
              <div className="flex flex-wrap justify-center gap-4">
                {socialLinks?.map((social, index) => (
                  <a
                    key={index}
                    href={social?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center gap-3 px-4 py-3 rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                  >
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300">
                      <Icon name={social?.icon} size={20} className="text-primary" />
                    </div>
                    <div className="text-left">
                      <div className="text-xs text-muted-foreground">{social?.label}</div>
                      <div className="text-sm font-medium text-foreground">{social?.handle}</div>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-card rounded-xl p-6 border border-border">
                <Icon name="Clock" size={32} className="text-primary mx-auto mb-3" />
                <div className="text-sm text-muted-foreground mb-1">Response Time</div>
                <div className="text-lg font-bold text-foreground">Within 24 Hours</div>
              </div>
              <div className="bg-card rounded-xl p-6 border border-border">
                <Icon name="Calendar" size={32} className="text-primary mx-auto mb-3" />
                <div className="text-sm text-muted-foreground mb-1">Project Timeline</div>
                <div className="text-lg font-bold text-foreground">2-12 Weeks</div>
              </div>
              <div className="bg-card rounded-xl p-6 border border-border">
                <Icon name="DollarSign" size={32} className="text-primary mx-auto mb-3" />
                <div className="text-sm text-muted-foreground mb-1">Starting From</div>
                <div className="text-lg font-bold text-foreground">$5,000 USD</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;